<template><div><h1 id="spende-umbuchen" tabindex="-1"><a class="header-anchor" href="#spende-umbuchen"><span>Spende umbuchen</span></a></h1>
<p>Spende umbuchen — Spende in manuellen Buchungen umbuchen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Wenn eine Spende irrtümlich auf ein falsches Ereignis gebucht wurde, kann mittels dieser Funktion die Spende auf eine anderes Ereignis umgebucht werden. Statt des ganzen Betrages kann auch nur ein Teil des Betrages umgebucht werden.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Spende umbuchen (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Umbuchung erfasst wird</dd>
<dt>Ereignis</dt>
<dd>Auswahl eines <a class="link" href="ft.refdata.ereigkopf.html" title="Ereignisse">Ereignisses</a> und einer <a class="link" href="ft.refdata.ereigpos.html" title="Ereignispositionen">Ereignisposition.</a> Statt eines Ereignisses kann aber auch die ESR-ID eingegeben werden.</dd>
<dt>Betrag</dt>
<dd>Den Umbuchungsbetrag eingeben</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


